(function () {
  const DATA = window.FUZED_FITMENT_DATA || [];

  function unique(values) {
    return [...new Set(values.filter(Boolean))];
  }

  function filterRows(rows, key, value) {
    return rows.filter(row => String(row[key]) === String(value));
  }

  function fillSelect(select, values, placeholder, labelFn) {
    select.innerHTML = "";

    const first = document.createElement("option");
    first.value = "";
    first.textContent = placeholder;
    select.appendChild(first);

    values.forEach(value => {
      const option = document.createElement("option");
      option.value = value;
      option.textContent = labelFn ? labelFn(value) : value;
      select.appendChild(option);
    });

    select.disabled = values.length === 0;
  }

  function showResult(root, type, title, body) {
    const result = root.querySelector("[data-fitment-result]");
    const titleEl = root.querySelector("[data-fitment-title]");
    const bodyEl = root.querySelector("[data-fitment-body]");

    result.classList.remove(
      "is-hidden",
      "is-fit",
      "is-no-fit",
      "is-unverified"
    );

    result.classList.add(type);
    titleEl.textContent = title;
    bodyEl.textContent = body;
  }

  function hideResult(root) {
    root.querySelector("[data-fitment-result]").classList.add("is-hidden");
  }

  function init(root) {
    const yearSelect = root.querySelector("[data-fitment-year]");
    const makeSelect = root.querySelector("[data-fitment-make]");
    const modelSelect = root.querySelector("[data-fitment-model]");
    const optionWrap = root.querySelector("[data-fitment-option-wrap]");
    const optionSelect = root.querySelector("[data-fitment-option]");
    const checkButton = root.querySelector("[data-fitment-check]");
    const resetButton = root.querySelector("[data-fitment-reset]");

    const productId = String(root.dataset.productId || "");

    const years = unique(DATA.map(row => row.year))
      .sort((a, b) => Number(b) - Number(a));

    fillSelect(yearSelect, years, "Select Year");

    makeSelect.disabled = true;
    modelSelect.disabled = true;
    optionSelect.disabled = true;
    optionWrap.hidden = true;

    yearSelect.addEventListener("change", function () {
      hideResult(root);

      let rows = filterRows(DATA, "year", yearSelect.value);

      const makes = unique(rows.map(row => row.make))
        .sort((a, b) => a.localeCompare(b));

      fillSelect(makeSelect, makes, "Select Make");
      fillSelect(modelSelect, [], "Select Model");
      fillSelect(optionSelect, [], "Select Headlight Type");

      optionWrap.hidden = true;
    });

    makeSelect.addEventListener("change", function () {
      hideResult(root);

      let rows = filterRows(DATA, "year", yearSelect.value);
      rows = filterRows(rows, "make", makeSelect.value);

      const models = unique(rows.map(row => row.model))
        .sort((a, b) => a.localeCompare(b));

      fillSelect(modelSelect, models, "Select Model");
      fillSelect(optionSelect, [], "Select Headlight Type");

      optionWrap.hidden = true;
    });

    modelSelect.addEventListener("change", function () {
      hideResult(root);

      let rows = filterRows(DATA, "year", yearSelect.value);
      rows = filterRows(rows, "make", makeSelect.value);
      rows = filterRows(rows, "model", modelSelect.value);

      const options = unique(rows.map(row => row.option));

      if (options.length > 1 || (options.length === 1 && options[0])) {
        fillSelect(
          optionSelect,
          options,
          "Select Headlight Type",
          value => value || "Standard / No special option"
        );

        optionWrap.hidden = false;
      } else {
        optionWrap.hidden = true;
        optionSelect.innerHTML =
          '<option value="">Standard / No special option</option>';
        optionSelect.disabled = false;
      }
    });

    checkButton.addEventListener("click", function () {
      hideResult(root);

      const year = yearSelect.value;
      const make = makeSelect.value;
      const model = modelSelect.value;
      const option = optionWrap.hidden ? "" : optionSelect.value;

      if (!year || !make || !model || (!optionWrap.hidden && !option)) {
        showResult(
          root,
          "is-unverified",
          "Select your complete vehicle first",
          "Choose the year, make, model" +
            (optionWrap.hidden ? "." : " and headlight type.")
        );
        return;
      }

      let matches = DATA.filter(row =>
        row.year === year &&
        row.make === make &&
        row.model === model &&
        row.option === option
      );

      if (!matches.length && option === "") {
        matches = DATA.filter(row =>
          row.year === year &&
          row.make === make &&
          row.model === model &&
          !row.option
        );
      }

      if (!matches.length) {
        showResult(
          root,
          "is-unverified",
          "Fitment not yet verified",
          "We don't currently have a verified fitment record for this exact configuration. Contact Fuzed LED before ordering."
        );
        return;
      }

      const productIds = unique(
        matches.flatMap(row => row.product_ids || [])
      );

      const vehicleName = [
        year,
        make,
        model,
        option
      ].filter(Boolean).join(" ");

      if (productIds.includes(productId)) {
        showResult(
          root,
          "is-fit",
          "✓ Confirmed fit for your vehicle",
          "This product is listed as compatible with your " + vehicleName + "."
        );
      } else {
        showResult(
          root,
          "is-no-fit",
          "This product is not listed for your selected vehicle",
          "We don't currently have this product assigned to your " + vehicleName + ". Check your vehicle-specific bulb guide or contact Fuzed LED before ordering."
        );
      }
    });

    resetButton.addEventListener("click", function () {
      yearSelect.value = "";

      fillSelect(makeSelect, [], "Select Make");
      fillSelect(modelSelect, [], "Select Model");
      fillSelect(optionSelect, [], "Select Headlight Type");

      optionWrap.hidden = true;
      hideResult(root);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll("[data-fuzed-fitment]")
      .forEach(init);
  });
})();